type Props = {
  kicker: string;
  title: string;
  desc?: string;
  accent?: boolean;
};

export default function SectionHeading({ kicker, title, desc, accent }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <span
        className={`inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold ${
          accent ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900"
        }`}
      >
        {accent ? <i className="ri-flashlight-fill text-[11px]" /> : <i className="ri-flag-line text-[11px]" />}
        {kicker}
      </span>
      <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className="max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
    </div>
  );
}